// extracted by mini-css-extract-plugin
module.exports = {"callbackContainer":"oAuthCallback_callbackContainer__1mog2","loadingText":"oAuthCallback_loadingText__1J36d","loadingIndicator":"oAuthCallback_loadingIndicator__zyp0b"};